import { useTranslation } from "react-i18next";
import { fieldTypes } from "../../../../../../../utils/config/widgetsConfig";

const useUsersCreateEditModal = ({
    isFetchingSubTenants, projectConfigurationsIsFetching, isEditMode
}) => {

    const { t } = useTranslation();

    const createEditModalConfig = [{
        title: t('Name'),
        dataIndex: 'username',
        editable: true,
        rule: /^[\p{L}\p{M}\p{S}\p{N}\p{P}]+$/u,
        required: true,
        ruleMessage: t('error.users_username'),
        fieldTypeOf: fieldTypes.textBox,
        disabled: isEditMode,
        description: isEditMode ? t("tooltip.username_not_editable") : undefined,
    },
    !isEditMode && {
        title: t('Temporary Password'),
        dataIndex: 'temporary_password',
        required: true,
        fieldTypeOf: fieldTypes.password,
        rule: /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~=+\- ]{8,256}$/,
        ruleMessage: t('error.users_temporary_password'),
        ruleValidateTrigger: 'onBlur',
        description: t('tooltip.users_temporary_password'),
    },
    {
        title: t('Phone Number'),
        dataIndex: 'phone_number',
        required: true,
        rule: /^\+[1-9]\d{1,14}$/,
        ruleMessage: t('error.users_phone_number'),
        ruleValidateTrigger: 'onBlur',
        fieldTypeOf: fieldTypes.textBox
    },
    {
        title: t('Email'),
        dataIndex: 'email',
        required: true,
        rule: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        ruleMessage: t('error.users_email'),
        ruleValidateTrigger: 'onBlur',
        fieldTypeOf: fieldTypes.textBox
    },
    {
        title: t('Tenant'),
        dataIndex: 'tenant',
        fieldTypeOf: fieldTypes.multiSelect,
        required: true,
        loading: isFetchingSubTenants,
        disabled: isFetchingSubTenants,
    },
    {
        title: t('Zones'),
        dataIndex: 'zones',
        fieldTypeOf: fieldTypes.multiSelect,
        size: 12,
        loading: projectConfigurationsIsFetching,
        disabled: projectConfigurationsIsFetching,
    },
    {
        title: t('Tags'),
        dataIndex: 'tags',
        fieldTypeOf: fieldTypes.multiSelect,
        size: 12,
        loading: projectConfigurationsIsFetching,
        disabled: projectConfigurationsIsFetching,
    }].filter(Boolean);

    return createEditModalConfig;
}

export default useUsersCreateEditModal